import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import PrimaryHeading from '../../Utilities/PrimaryHeading';
import Grid from "@mui/material/Grid";

const data = [
  'Systematic elimination of costly quality issues',
  'Improve customer satisfaction and supplier credibility',
  'Streamline corrective and preventive actions',
  'Boost operational efficiency with AI integration',
  'Generate instant, shareable reports',
  'Maintain compliance with industry standards',
  'Upskilling of engaged person over time',
];

export default function BenefitsOfNcpro() {

  const [active, setActive] = useState(null);

  return (
    <Container maxWidth={false}
      sx={{
        backgroundImage: `url('/images/benefitsOfNcproBg.png')`,
        backgroundColor: 'rgba(241, 244, 255, 1)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '500px',
        paddingTop: '40px',
        paddingBottom: '15px',
        position: 'relative',
      }}
    >
      <Container maxWidth='xl'>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Box>
              <PrimaryHeading sx={{
                textAlign: { xs: 'center', md: 'left' },
                paddingBottom: '30px'
              }}><span style={{
                color: 'white',
                background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                opacity: '90%',
                marginRight: '5px'
              }}>Benefits</span>
                of NC pro:
              </PrimaryHeading>
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              {data.map((item, index) => (
                <Grid key={index} xs={12} md={4}>
                  <Box
                    component="ul"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      minHeight: '116px',
                      listStyleType: 'none',
                      margin: '12px',
                      p: 2,
                      borderRadius: '10px',
                      border: '1px solid #EBEBEB',
                      backdropFilter: 'blur(4px)',
                      backgroundColor: '#FFFFFF73',
                      cursor: 'default',
                      '&:hover': {
                        backgroundColor: 'white',
                      }
                    }}
                    onMouseEnter={() => setActive(index)}
                    onMouseLeave={() => setActive(null)}
                  >
                    <li
                      style={{
                        position: 'relative',
                        paddingLeft: '20px',
                        fontSize: '18px',
                        fontWeight: '400',
                        lineHeight: '21.6px',
                        textAlign: 'left',
                        letterSpacing: '0.02em',
                        color: active === index ? 'rgba(42, 61, 189, 1)' : '#545454',
                        textUnderlinePosition: 'from-font',
                        textDecorationSkipInk: 'none',
                        '&:hover': {
                          color: 'rgba(42, 61, 189, 1)',
                        }
                      }}
                    >
                      <span
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: '24%',
                          transform: 'translateY(-50%)',
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: active === index ? 'rgba(42, 61, 189, 1)' : '#545454',
                          opacity: '60%',
                        }}
                      />
                      {item}
                    </li>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Container>
  )
}